// extracted by mini-css-extract-plugin
module.exports = {"section":"easy-installation_section__jWpaW","wrapper":"easy-installation_wrapper__SwSbS"};